import HStack from "shared/components/layout/stack/HStack";
import { COLOR_VALUES } from "shared/config/colors";
import styled, { css } from "styled-components";

export const Wrapper = styled.div`
    width: max-content;
    height: auto;
    font-size: 0;
    display: flex;
    align-items: center;

    ${({ $disabled }) =>
        $disabled &&
        css`
            cursor: not-allowed;
        `};
`;

export const StyledLabel = styled(HStack).attrs({ forwardedAs: "label" })`
    position: relative;

    ${({ $disabled }) =>
        $disabled
            ? css`
                  color: ${COLOR_VALUES.Gray_4};
                  pointer-events: none;
                  user-select: none;
              `
            : css`
                  &:hover {
                      color: ${COLOR_VALUES.Gray_2};
                  }
              `}
`;
